import type { AggregatedChanges } from '../change_trackers/InputGroupChangeTracker';
import type { ComparisonInputGroup } from '../models/contract_comparison/ComparisonNodeBaseModel';
import { InputChangeType } from '../types';

export type ContractComparisonFilter = 'all' | 'onlyWithChanges' | 'withoutChanges' | InputChangeType;

export function getVisibleComparisonGroups<T extends ComparisonInputGroup>(
    groups: T[],
    selectedFilter: ContractComparisonFilter
): T[] {
    return groups
        .filter(group => !group.isHidden)
        .filter(group => getVisibleComparisonInputIds(selectedFilter, group.inputIds, group.changes).length > 0);
}

export const getVisibleComparisonInputIds = (
    selectedFilter: ContractComparisonFilter,
    inputIds: string[],
    changes: AggregatedChanges
): string[] => {
    switch (selectedFilter) {
        case 'all':
            return inputIds;
        case 'onlyWithChanges':
            return changes.changeRecords.map(record => record.inputId);
        case 'withoutChanges':
            return inputIds.filter(inputId => !changes.changeRecords.some(record => record.inputId === inputId));
        case 'added':
        case 'removed':
        case 'modified':
        case 'unsaved':
            return changes.counts[selectedFilter].inputIds;
        default:
            return inputIds;
    }
};
